import _ from 'lodash';

export default class ThumbBucketProfileTooth {
  constructor(item) {
    if (item) {
      this.toothCount = item.toothCount;
      this.toothStyle = item.toothStyle;
      return;
    }
    this.toothCount = null;
    this.toothStyle = null;
  }

  getForDisplay() {
    return this.toothCount.toString() + ' tooth / ' + this.toothStyle;
  }

  clone() {
    return _.cloneDeep(this);
  }
}
